import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

   // BehaviorSubject untuk menyimpan state sidebar
   private sidebarVisible = new BehaviorSubject<boolean>(true);

   // Observable yang bisa disubscribe component
   sidebarState$: Observable<boolean> = this.sidebarVisible.asObservable();

   constructor() {
     // Cek localStorage saat service diinisialisasi
     const savedState = localStorage.getItem('sidebarState');
     if (savedState) {
       this.sidebarVisible.next(JSON.parse(savedState));
     }
   }

   // Method untuk toggle sidebar
   toggleSidebar(): void {
     const currentState = this.sidebarVisible.value;
     this.sidebarVisible.next(!currentState);
     // Simpan state ke localStorage
     localStorage.setItem('sidebarState', JSON.stringify(!currentState));
   }

   // Method untuk membuka sidebar
   openSidebar(): void {
     this.sidebarVisible.next(true);
     localStorage.setItem('sidebarState', 'true');
   }

   // Method untuk menutup sidebar
   closeSidebar(): void {
     this.sidebarVisible.next(false);
     localStorage.setItem('sidebarState', 'false');
   }

   // Method untuk mendapatkan current state
   getCurrentState(): boolean {
     return this.sidebarVisible.value;
   }
}
